export default function Leaf({ attributes, children, leaf }) {
  const { bold, code, italic, underline, text } = leaf;

  let styledChildren = children;

  if (bold) {
    styledChildren = <strong>{styledChildren}</strong>;
  }

  if (code) {
    styledChildren = <code>{styledChildren}</code>;
  }

  if (italic) {
    styledChildren = <em>{styledChildren}</em>;
  }

  if (underline) {
    styledChildren = <u>{styledChildren}</u>;
  }

  return (
    <span className={text === "" ? "pl-0.5" : undefined} {...attributes}>
      {styledChildren}
    </span>
  );
}
